/* eslint-disable import/order */
/* eslint-disable no-unused-vars */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable camelcase */
import AddIcon from '@mui/icons-material/Add';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SecurityIcon from '@mui/icons-material/Security';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import Markdown from 'markdown-to-jsx';
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Card,
  CardHeader,
  Chip,
  Divider,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Toolbar,
  Typography,
  Icon,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { display, styled } from '@mui/system';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import axios from 'axios';
import dayjs from 'dayjs';
import { TextField as TextFieldFormik } from 'formik-mui';

import { Field, Form, Formik } from 'formik';
import Image from 'next/image';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { BeatLoader } from 'react-spinners';
import Typewriter from 'typewriter-effect';
import * as Yup from 'yup';
import document_text from '../../../public/assets/document_text.svg';
import email from '../../../public/assets/email.svg';
import { tokens } from '../../../src/tokens';
import SendIcon from '@mui/icons-material/Send';

// Header on selected contact
const EntityText = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,  sans-serif',
  fontSize: '0.87500rem',
  lineHeight: '1.00rem',
  fontWeight: 500,
  letterSpacing: '.0107142867em',
  // alignItems: 'center',
  color: tokens.token_typography_headline,
  textAlign: 'left',
}));
// Subheader on selected contact
const OriginText = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,  sans-serif',
  fontSize: '0.87500rem',
  lineHeight: '1.00rem',
  fontWeight: 400,
  letterSpacing: '.0107142867em',
  // alignItems: 'center',
  color: tokens.token_text_grey_on_grey,
  textAlign: 'left',
}));

// Explainer on white background
const HelperText = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,  sans-serif',
  fontSize: '0.87500rem',
  lineHeight: '1.00rem',
  fontWeight: 400,
  letterSpacing: '.0107142867em',
  // alignItems: 'center',
  color: tokens.token_text_grey_on_white,
  textAlign: 'left',
}));

const ExampleText = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,  sans-serif',
  fontSize: '0.80500rem',
  lineHeight: '1.00rem',
  fontWeight: 400,
  letterSpacing: '.0107142867em',
  marginTop: '5px',
  color: tokens.token_typography_regular,
  textAlign: 'left',
}));

// Section headers
const TopHeaderShow = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,  sans-serif',
  fontSize: '24px',
  lineHeight: '1.00rem',
  fontWeight: 600,
  letterSpacing: '.0107142867em',
  marginBottom: '15px',
  color: tokens.palette_primary,
  textAlign: 'left',
}));

function interactive_report_new(props) {
  const router = useRouter();
  const messageEl = useRef(null);
  const myQuestionBoxRef = useRef(null);
  const { agencyID, userName } = router.query;
  const [inputValue, setInputValue] = useState('');
  const [messagesArray, setMessagesArray] = useState([]);
  const [tampBubble, setTampBubble] = useState([]);
  const [openReviewModel, setOpenReviewModel] = useState(false);
  const [openAddAgencyModel, setOpenAddAgencyModel] = useState(false);
  const [questionBoxHeight, setQuestionBoxHeight] = useState(0);
  const [getAgencyDataById, setGetAgencyDataById] = useState([]);
  const [agencyTextTempSave, setAgencyTextTempSave] = useState([]);
  const [allAgencyData, setAllAgencyData] = useState([]);
  const [uniqueAgencyData, setUniqueAgencyData] = useState([]);
  const [openBankDetailsPopUp, setOpenBankDetailsPopUp] = useState(false);
  const [currentQuestionData, setCurrentQuestionData] = useState([]);
  const [questionsLoading, setQuestionsLoading] = useState(false);
  const [lastQuestionFlag, setLastQuestionFlag] = useState(false);

  // question box current height get
  useEffect(() => {
    if (myQuestionBoxRef.current) {
      const newHeight = myQuestionBoxRef.current.clientHeight;
      setQuestionBoxHeight(newHeight);
    }
  });

  // unique agency find
  useEffect(() => {
    const uniqueItems = Array.from(
      new Set(getAgencyDataById.map((agency) => agency?._id))
    ).map((id) => {
      return getAgencyDataById.find((agency) => agency?._id === id);
    });
    setUniqueAgencyData(uniqueItems);
  }, [getAgencyDataById]);

  const questionsGetApi = (questionID) => {
    const questionIdPayload = questionID ? questionID : 'str-001';
    setQuestionsLoading(true);
    axios
      .get(`/api/questions/${questionIdPayload}`)
      .then((response) => {
        // Store the API response in state
        setCurrentQuestionData(response.data);
        setQuestionsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  };

  useEffect(() => {
    questionsGetApi();
  }, []);

  // for sending message by pressing enter
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSendMessage();
    }
  };

  // for date picker value set
  const handleOnlyDateChange = (date) => {
    setInputValue(dayjs(date).format('YYYY/MM/DD'));
    // setInputValue(dayjs(date).format('DD/MM/YYYY hh:mm:ss A'))
  };

  // for date & time picker value set
  const handleDateTimeChange = (date) => {
    setInputValue(dayjs(date).format());
  };

  // input value get
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  // message sending
  const handleSendMessage = (data, inputSetVal) => {
    if (data?.answer_text || inputSetVal?.toString() || inputValue) {
      if (
        data &&
        currentQuestionData?.data?.[0]?.rules &&
        !currentQuestionData?.data?.[0]?.rules[0]?.secondary_question_id &&
        !currentQuestionData?.data?.[0]?.rules[0]?.tertiary_question_id
      ) {
        let findNextQuestionID = currentQuestionData?.data?.[0]?.rules.filter(
          (item) => {
            if (
              item.primary_question_id == data?.question_id &&
              item.primary_answer_id == data?.answer_id
            ) {
              return item;
            }
          }
        );
        questionsGetApi(findNextQuestionID?.[0].next_question_id);
        findNextQuestionID?.[0].next_question_id == 'last_q' &&
          setLastQuestionFlag(true);
        const eventData = {
          questionID: data?.question_id,
          answer: data?.answer_text,
          question: currentTypeWriterQuestion()?.question,
          pdfQuestion: currentTypeWriterQuestion()?.pdfQuestion,
          mainHeader: currentTypeWriterQuestion()?.mainHeader,
          answerId: data?.answer_id,
        };
        setMessagesArray((prevMessages) =>
          prevMessages.length === 0 ? [eventData] : [...prevMessages, eventData]
        );
        setInputValue('');
      }
      if (
        !data &&
        currentQuestionData?.data?.[0]?.rules &&
        !currentQuestionData?.data?.[0]?.rules[0]?.secondary_question_id &&
        !currentQuestionData?.data?.[0]?.rules[0]?.tertiary_question_id
      ) {
        questionsGetApi(
          currentQuestionData?.data?.[0]?.rules?.[0]?.next_question_id
        );
        currentQuestionData?.data?.[0]?.rules?.[0]?.next_question_id ==
          'last_q' && setLastQuestionFlag(true);
        const eventData = {
          questionID: currentTypeWriterQuestion()?.questionID,
          answer: inputSetVal?.toString() || inputValue,
          question: currentTypeWriterQuestion()?.question,
          pdfQuestion: currentTypeWriterQuestion()?.pdfQuestion,
          mainHeader: currentTypeWriterQuestion()?.mainHeader,
          ...(inputSetVal?.toString() && { shownData: true }),
        };
        setMessagesArray((prevMessages) =>
          prevMessages.length === 0 ? [eventData] : [...prevMessages, eventData]
        );
        setInputValue('');
      }
      if (
        currentQuestionData?.data?.[0]?.rules &&
        currentQuestionData?.data?.[0]?.rules[0]?.secondary_question_id &&
        currentQuestionData?.data?.[0]?.rules[0]?.tertiary_question_id
      ) {
        const secondaryQuestionIdFind = tampBubble
          .flat()
          .find(
            (item) =>
              item.questionID ===
              currentQuestionData?.data?.[0]?.rules[0]?.secondary_question_id
          );
        const tertiaryQuestionId = tampBubble
          .flat()
          .find(
            (item) =>
              item.questionID ===
              currentQuestionData?.data?.[0]?.rules[0]?.tertiary_question_id
          );
        if (secondaryQuestionIdFind) {
          let findNextQuestionID = currentQuestionData?.data?.[0]?.rules.filter(
            (item) => {
              if (
                item?.secondary_answer_id == secondaryQuestionIdFind?.answerId
              ) {
                return item;
              }
            }
          );
          findNextQuestionID?.[0]?.next_question_id &&
            questionsGetApi(findNextQuestionID?.[0]?.next_question_id);
        }
        if (tertiaryQuestionId) {
          let findNextQuestionID = currentQuestionData?.data?.[0]?.rules.filter(
            (item) => {
              if (
                item?.tertiary_answer_id == secondaryQuestionIdFind?.answerId
              ) {
                return item;
              }
            }
          );
          findNextQuestionID?.[0]?.tertiary_next_question_id &&
            questionsGetApi(findNextQuestionID?.[0]?.tertiary_next_question_id);
        }
      }
    }
  };

  const answerFormatCheck = () => {
    if (
      currentQuestionData?.data?.[0]?.answer_format?.trim() == 'alphanumeric'
    ) {
      return 'alphanumeric';
    }
    if (currentQuestionData?.data?.[0]?.answer_format?.trim() == 'numeric') {
      return 'number';
    }
    if (currentQuestionData?.data?.[0]?.answer_format?.trim() == 'text') {
      return 'text';
    }
  };

  // bubble array set
  useEffect(() => {
    // Create a map to store the grouped data
    const groupedData = new Map();

    // Iterate through the original array
    messagesArray.forEach((item) => {
      // Extract the first 3 characters of questionID
      const questionIDPrefix = item.questionID.substring(0, 3);

      // Use mainHeader or "NoHeader" if it's null
      const mainHeader = item.mainHeader || 'NoHeader';

      // Create a unique key based on the combination of questionID and mainHeader
      const key = `${questionIDPrefix}-${mainHeader}`;

      // Check if the key exists in the map
      if (!groupedData.has(key)) {
        // If not, initialize it as an empty array
        groupedData.set(key, []);
      }

      // Add the item to the corresponding subarray
      groupedData.get(key).push(item);
    });
    // Convert the map values into an array of subarrays
    const groupedArray = Array.from(groupedData.values());

    // Now, groupedArray contains subarrays of objects based on the first 3 characters of questionID and mainHeader
    setTampBubble(groupedArray);
  }, [messagesArray]);

  // intro question manage
  const handleIntroQuestion = () => {
    questionsGetApi(
      currentQuestionData?.data?.[0]?.rules?.[0].next_question_id
    );
  };

  // unKnown messages function

  const handleUnKnownMessage = () => {
    questionsGetApi(
      currentQuestionData?.data?.[0]?.rules?.[0].next_question_id
    );
    const eventData = {
      questionID: currentTypeWriterQuestion()?.questionID,
      answer: 'unKnown',
      question: currentTypeWriterQuestion()?.question,
      pdfQuestion: currentTypeWriterQuestion()?.pdfQuestion,
      mainHeader: currentTypeWriterQuestion()?.mainHeader,
    };
    setMessagesArray((prevMessages) =>
      prevMessages.length === 0 ? [eventData] : [...prevMessages, eventData]
    );
    setInputValue('');
    currentQuestionData?.data?.[0]?.rules?.[0]?.next_question_id == 'last_q' &&
      setLastQuestionFlag(true);
  };

  // input filed return function
  const inputGenerator = () => {
    if (currentQuestionData?.data?.[0]?.answer_type?.trim() == 'selection') {
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <Box
            sx={{
              p: '5px 0px',
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              borderRadius: '40px',
              flexWrap: { xs: 'nowrap', md: 'wrap' },
              overflow: 'auto',
              '&::-webkit-scrollbar': {
                display: 'none',
              },
            }}
          >
            {currentQuestionData?.data?.[0]?.answers?.map((item) => {
              return (
                <Box sx={{ margin: '5px 5px' }}>
                  <Chip
                    sx={{
                      backgroundColor: tokens.palette_primary,
                      color: tokens.token_surface,
                      paddingLeft: '8px',
                      paddingRight: '8px',
                      fontWeight: 500,
                      '&:hover': {
                        backgroundColor: tokens.palette_secondary,
                      },
                    }}
                    label={item?.answer_text}
                    icon={
                      item?.answer_text.toLowerCase() === 'yes' ? (
                        <>
                          <CheckIcon
                            sx={{
                              color: tokens.token_surface,
                              fontSize: 20,
                            }}
                          />
                        </>
                      ) : item?.answer_text.toLowerCase() === 'no' ? (
                        <>
                          <CloseIcon
                            sx={{
                              color: tokens.token_surface,
                              fontSize: 20,
                              lineHeight: '24px',
                            }}
                          />
                        </>
                      ) : null
                    }
                    onClick={() => {
                      {
                        handleSendMessage(item);
                      }
                    }}
                  />
                </Box>
              );
            })}
          </Box>
          <Box>
            {currentQuestionData?.data?.[0]?.usage?.trim() == 'optional' && (
              <Button
                variant="contained"
                sx={{ textTransform: 'none' }}
                onClick={() => {
                  handleUnKnownMessage();
                }}
              >
                unKnown
              </Button>
            )}
          </Box>
        </Box>
      );
    }
    if (currentQuestionData?.data?.[0]?.answer_type?.trim() == 'startq') {
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <Box
            sx={{
              p: '5px 0px',
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              borderRadius: '40px',
              flexWrap: { xs: 'nowrap', md: 'wrap' },
              overflow: 'auto',
              '&::-webkit-scrollbar': {
                display: 'none',
              },
            }}
          >
            {currentQuestionData?.data?.[0]?.answers?.map((item) => {
              return (
                <Box sx={{ margin: '5px 5px' }}>
                  <Chip
                    sx={{
                      backgroundColor: tokens.palette_primary,
                      color: tokens.token_surface,
                      paddingLeft: '8px',
                      paddingRight: '8px',
                      fontWeight: 500,
                      '&:hover': {
                        backgroundColor: tokens.palette_secondary,
                      },
                    }}
                    label={item?.answer_text}
                    onClick={() => {
                      {
                        handleIntroQuestion();
                      }
                    }}
                  />
                </Box>
              );
            })}
          </Box>
        </Box>
      );
    }
    if (currentQuestionData?.data?.[0]?.answer_type?.trim() == 'entery') {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            // background: { xs: 'transparent', sm: 'transparent' },
            backgroundColor: tokens.token_surface,
            borderRadius: { xs: '15px', sm: '15px' },
            border: `1px solid ${tokens.token_search_border_grey}`,
            padding: { xs: '4px 8px 0px 8px', sm: '4px 8px 0px 8px' },
            height: '130px',
            // margin: '15px 30px 30px 30px',
            width: '100%',
          }}
        >
          <Box
            sx={{
              height: '80px',
              width: '100%',
              padding: '0px 8px',
              borderRadius: {
                xs: '15px 15px 0px 0px',
                sm: '15px 15px 0px 0px',
              },
            }}
          >
            <InputBase
              sx={{
                height: '100%',
                width: '100%',
                alignItems: 'flex-start',
                backgroundColor: tokens.token_surface,
                borderRadius: '4px'
              }}
              placeholder="Message"
              inputProps={{ 'aria-label': 'Message' }}
              value={inputValue}
              onChange={(e) => handleInputChange(e)}
              onKeyPress={handleKeyPress}
              multiline
              rows={3}
              autoFocus
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderTop: `1px solid ${tokens.token_search_border_grey}`,
              height: '50px',
              width: '100%',
              padding: '0px 8px',
              borderRadius: {
                xs: '0px 0px 15px 15px',
                sm: '0px 0px 15px 15px',
              },
            }}
          >
            <Box>
              <Box>
                {currentQuestionData?.data?.[0]?.usage?.trim() ==
                  'optional' && (
                  <Button
                    variant="contained"
                    sx={{
                      textTransform: 'none',
                      borderRadius: '30px',
                      marginRight: '20px',
                      padding: '5px 15px',
                    }}
                    onClick={() => {
                      handleUnKnownMessage();
                    }}
                  >
                    Unknown
                  </Button>
                )}
              </Box>
            </Box>
            <Box>
              <Button
                disableElevation
                variant="contained"
                onClick={() => handleSendMessage()}
                endIcon={<SendIcon />}
                sx={{
                  height: '32px',
                  textTransform: 'none',
                  borderRadius: '8px'
                }}
              >
                Send
              </Button>
            </Box>
          </Box>
        </Box>
      );
    }
    if (
      currentQuestionData?.data?.[0]?.answer_type?.trim() == 'date_time_picker'
    ) {
      return (
        <>
          <Box
            elevation={0}
            component="form"
            sx={{
              p: '5px 0px 5px 15px',
              display: 'flex',
              alignItems: 'center',
              width: 'calc(100% - 60px)',
              // height: '56px',
              borderRadius: '30px',
              flexWrap: 'wrap',
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                value={inputValue}
                onChange={handleDateTimeChange}
                slotProps={{ textField: { variant: 'standard' } }}
                InputProps={{
                  disableUnderline: true,
                }}
                sx={{
                  '& .MuiInput-underline:before, & .MuiInput-underline:after': {
                    borderBottom: 'none',
                  },
                }}
              />
            </LocalizationProvider>
          </Box>
          <Box>
            {currentQuestionData?.data?.[0]?.usage?.trim() == 'optional' && (
              <Button
                disableElevation
                variant="contained"
                sx={{ textTransform: 'none' }}
                onClick={() => {
                  handleUnKnownMessage();
                }}
              >
                Unknown
              </Button>
            )}
          </Box>
          <IconButton
            color="primary"
            component="span"
            sx={WebStyle.send_icon}
            onClick={() => {
              handleSendMessage();
            }}
          >
            <ArrowUpwardIcon />
          </IconButton>
        </>
      );
    }
    if (currentQuestionData?.data?.[0]?.answer_type?.trim() == 'date_picker') {
      return (
        <>
          <Box
            elevation={0}
            component="form"
            sx={{
              p: '5px 0px 5px 15px',
              display: 'flex',
              alignItems: 'center',
              width: 'calc(100% - 60px)',
              // height: '56px',
              borderRadius: '40px',
              flexWrap: 'wrap',
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={inputValue}
                onChange={handleOnlyDateChange}
                slotProps={{ textField: { variant: 'standard' } }}
                InputProps={{
                  disableUnderline: true,
                }}
                sx={{
                  '& .MuiInput-underline:before, & .MuiInput-underline:after': {
                    borderBottom: 'none',
                  },
                }}
              />
            </LocalizationProvider>
          </Box>
          <Box>
            {currentQuestionData?.data?.[0]?.usage?.trim() == 'optional' && (
              <Button
                disableElevation
                variant="contained"
                sx={{ textTransform: 'none' }}
                onClick={() => {
                  handleUnKnownMessage();
                }}
              >
                Unknown
              </Button>
            )}
          </Box>
          <IconButton
            color="primary"
            component="span"
            sx={WebStyle.send_icon}
            onClick={() => {
              handleSendMessage();
            }}
          >
            <ArrowUpwardIcon />
          </IconButton>
        </>
      );
    }
    if (currentQuestionData?.data?.[0]?.answer_type?.trim() == 'function') {
      let lastDightFetch = currentQuestionData?.data?.[0]?.question_id?.charAt(
        currentQuestionData?.data?.[0]?.question_id?.length - 1
      );
      let changeId =
        currentQuestionData?.data?.[0]?.question_id?.slice(0, -1) +
        (lastDightFetch - 1);

      const foundItem = tampBubble
        .flat()
        .find((item) => item.questionID === changeId);

      const birthdate = new Date(foundItem?.answer);
      const currentDate = new Date();
      const timeDifference = currentDate - birthdate;

      const ageDate = new Date(timeDifference);

      const years = Math.abs(ageDate.getUTCFullYear() - 1970);
      handleSendMessage(undefined, years);
    }
  };

  // show current question
  const currentTypeWriterQuestion = () => {
    let tempQuestion;
    const questionDetails = currentQuestionData?.data?.[0];
    if (questionDetails) {
      tempQuestion = {
        questionID: questionDetails?.question_id,
        question: questionDetails?.question_text,
        pdfQuestion: questionDetails?.pdf_header,
        helperText: questionDetails?.helper_text,
        mainHeader: questionDetails?.report_header,
      };
      return tempQuestion;
    }
  };

  // agency model state management
  const handleAddAgencyOpen = () => {
    setOpenAddAgencyModel(true);
  };
  const handleAddAgencyClose = () => {
    setOpenAddAgencyModel(false);
  };

  // manage selected agency remove
  const remainingAgencies = allAgencyData.filter(
    (agency) => !getAgencyDataById.includes(agency)
  );

  const uniqueIds = new Set(getAgencyDataById.map((item) => item?._id));

  const filteredArrayAgency = remainingAgencies.filter(
    (item) => !uniqueIds.has(item._id)
  );

  // delete agency in array
  const deleteByIdAgent = (id) => {
    setGetAgencyDataById((oldValues) => {
      return oldValues.filter((array) => array?._id !== id);
    });
  };

  // selected all agency id find
  const selectedAllArrayIdFind = getAgencyDataById.map((item) => item?._id);

  // agency model click before data store in state
  const handleAgencyDataClick = (data) => {
    if (data?.isBank) {
      handleAddAgencyClose();
      handleBankDetailsPopUpOpen();
      setAgencyTextTempSave(data);
      setGetAgencyDataById((prev) => [...prev, data]);
    } else {
      setGetAgencyDataById((prev) => [...prev, data]);
      handleAddAgencyClose();
    }
  };

  // bank details model state management
  const handleBankDetailsPopUpOpen = () => {
    setOpenBankDetailsPopUp(true);
  };
  const handleBankDetailsPopUpClose = () => {
    setOpenBankDetailsPopUp(false);
    const updatedData = getAgencyDataById.filter(
      (item) => item._id !== agencyTextTempSave._id
    );
    setGetAgencyDataById(updatedData);
  };

  // Account details form forMik manage
  const initialValues = {
    bankAccountNumber: '',
    bankAccountPin: '',
    bankPassword: '',
  };

  let validationSchema = Yup.object().shape({
    bankAccountNumber: Yup.string().required('Required'),
    bankAccountPin: Yup.string().required('Required'),
    bankPassword: Yup.string().required('Required'),
  });

  const onSubmit = (values) => {
    const payload = {
      bankAccountNumber: values?.bankAccountNumber,
      bankAccountPin: values?.bankAccountPin,
      bankPassword: values?.bankPassword,
    };
    axios
      .post('/api/bank/details', payload)
      .then((response) => {
        setGetAgencyDataById((prev) => [...prev, agencyTextTempSave]);
        handleAddAgencyClose();
        setOpenBankDetailsPopUp(false);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // review model manage
  const handleOpenReviewModel = () => {
    setOpenReviewModel(true);
  };

  const handleCloseReviewModel = () => {
    setOpenReviewModel(false);
  };

  // email open
  const handleEmailButtonClick = () => {
    const mailtoUrl = `mailto:`;
    window.open(mailtoUrl);
  };

  // outside click model not close
  const handleBackdropClick = (event) => {
    // Prevent closing the dialog when clicking outside
    event.stopPropagation();
  };

  useEffect(() => {
    if (messageEl) {
      messageEl.current.addEventListener('DOMNodeInserted', (event) => {
        const { currentTarget: target } = event;
        target.scroll({ top: target.scrollHeight });
      });
    }
  }, []);

  // page back route setup
  const handleBack = () => {
    router.push('/blockquiry_connect/u/select_agency');
    window.location.href = '/blockquiry_connect/u/select_agency';
  };

  // image/pdf upload
  const handleImageUpload = (event) => {
    const files = event.target.files;
    const totalFiles = files.length;
    // Array to store base64 encoded data of all selected files
    const base64ImagesTemp = [];
    let filesProcessed = 0;
    const handleReaderLoadEnd = (reader, file) => {
      // Callback when the file reading is completed
      const base64String = reader.result;
      base64ImagesTemp.push(base64String);
      filesProcessed++;
      if (filesProcessed === totalFiles) {
        // All files have been processed, update the state with the base64Images array
        setBase64Image(base64ImagesTemp);
        // Perform your logic with the base64Images array (e.g., send it to the server)
        // Call handleSendMessage() or any other function that requires the base64Images array.
        handleSendMessage();
      }
    };

    for (let i = 0; i < totalFiles; i++) {
      const file = files[i];
      const reader = new FileReader();
      if (file.size > currentIndexNewA?.maxSize) {
        alert(`File maximum size limit of 5 MB.`);
        continue; // Skip processing this file and move to the next one
      }
      reader.onloadend = () => {
        handleReaderLoadEnd(reader, file);
      };
      reader.readAsDataURL(file);
    }
  };

  // Agency data get request( all agency)
  const getAgencyDataApi = () => {
    axios
      .get('/api/agencies')
      .then((response) => {
        // Store the API response in state
        setAllAgencyData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  };

  useEffect(() => {
    getAgencyDataApi();
  }, []);

  // submit report api integration
  const handleSubmitReport = () => {
    const payload = {
      // agencyID: agencyID,
      agencyID: selectedAllArrayIdFind,
      report: tampBubble,
      name: userName,
    };
    axios
      .post('/api/reports', payload)
      .then((response) => {
        router.push('/blockquiry_connect/u/select_agency');
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  };

  // agency data get request (selected agency)
  const getAgencyDataApiById = () => {
    if (agencyID) {
      axios
        .get(`/api/agencies/${agencyID}`)
        .then((response) => {
          setGetAgencyDataById([response.data.data]); // Store the API response in state
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    }
  };

  useEffect(() => {
    if (agencyID) {
      getAgencyDataApiById();
    }
  }, [agencyID]);

  // page style
  const WebStyle = {
    bot_chat_all_message: {
      width: '100vw',
      height: '100vh',
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    chat_message_send: {
      borderRadius: '30px',
      width: 'fit-content',
      // COLOR OF THE QUESTION INNER BORDER
      backgroundColor: tokens.token_grey_300,
      // COLOR OF THE QUESTION OUTER BORDER
      border: `2px solid ${tokens.token_surface}`,
      wordBreak: 'break-all',
      margin: '10px 0',
      color: tokens.palette_secondary,
      fontWeight: '500',
      // padding: '15px 25px',
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'start',
    },
    message_font: {
      fontSize: '16px',
      fontWeight: 500,
      // COLOR OF THE QUESTION FONT
      color: tokens.palette_primary,
    },
    message_font_header: {
      fontSize: '20px',
      fontWeight: 600,
      color: tokens.token_surface,
    },
    message_answer: {
      fontSize: '16px',
      fontWeight: 500,
      // COLOR OF THE USER RESPONSE FONT
      color: tokens.token_surface,
      // color: 'rgba(0, 0, 0, 0.40)',
    },
    message_answer_review: {
      fontSize: '16px',
      fontWeight: 500,
      // COLOR OF THE USER RESPONSE FONT
      // color: tokens.token_surface,
      color: 'rgba(0, 0, 0, 0.40)',
    },
    send_icon: {
      backgroundColor: tokens.palette_primary,
      color: '#FFFFFF',
      height: '54px',
      marginRight: '6px',
      width: '54px',
      '&:hover': {
        backgroundColor: tokens.palette_secondary,
        color: '#FFFFFF',
      },
      '&.Mui-disabled': {
        color: 'white',
        backgroundColor: 'rgba(11, 43, 59, 0.8)',
      },
    },
    startHindQHelperText: {
      fontSize: '16px',
      fontWeight: '500',
      borderRadius: '20px',
      border: '1px solid rgb(204, 204, 204)',
      padding: '25px',
      boxShadow:
        '0px 3px 3px - 2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)',
      backgroundColor: tokens.token_grey_100,
      margin: '0',
      maxWidth: '650px',
    },
  };

  const extractContent = (input, tagName) => {
    const regex = new RegExp(`<${tagName}>(.*?)<\\/${tagName}>`, 'g');
    const matches = [];
    let match;
    while ((match = regex.exec(input)) !== null) {
      matches.push(match[1]);
    }
    return matches;
  };

  const helperTextShow = () => {
    const titleContent = extractContent(
      currentTypeWriterQuestion()?.helperText,
      'title'
    );
    const bulletContent = extractContent(
      currentTypeWriterQuestion()?.helperText,
      'bullet'
    );
    const numericContent = extractContent(
      currentTypeWriterQuestion()?.helperText,
      'numeric'
    );
    const alphanumericContent = extractContent(
      currentTypeWriterQuestion()?.helperText,
      'alphanumeric'
    );

    return (
      <>
        {titleContent.length > 0 &&
          titleContent.map((content, index) => (
            <Typography key={index}>{content}</Typography>
          ))}
        {bulletContent.length > 0 && (
          <ul style={{ paddingLeft: '16px', margin: '0px' }}>
            {bulletContent.map((content, index) => (
              <li key={index}>{content}</li>
            ))}
          </ul>
        )}
        {numericContent.length > 0 && (
          <ol>
            {numericContent.map((content, index) => (
              <li key={index}>{content}</li>
            ))}
          </ol>
        )}
        {alphanumericContent.length > 0 && (
          <ol type="A">
            {alphanumericContent.map((content, index) => (
              <li key={index}>{content}</li>
            ))}
          </ol>
        )}
      </>
    );
    // {
    //   alphanumericContent.length > 0 && (
    //     <ol type="A">
    //       {alphanumericContent.map((content, index) => (
    //         <li key={index}>{content}</li>
    //       ))}
    //     </ol>
    //   )
    // }
    // const helperText = currentTypeWriterQuestion()?.helperText || '';
    // const roundBulletShow = helperText.split('\\b');
    // const alphabetShow = helperText.split('\\a');
    // const numberShow = helperText.split('\\n');
    // if (roundBulletShow?.length > 1) {
    //   return (
    //     <>
    //       <ul style={{ paddingLeft: '16px', margin: '0px' }}>
    //         {roundBulletShow.map((line, index) => (
    //           <li key={index}>{line}</li>
    //         ))}
    //       </ul>
    //     </>
    //   );
    // } else if (alphabetShow?.length > 1) {
    //   return (
    //     <>
    //       <ol type="A" style={{ paddingLeft: '16px', margin: '0px' }}>
    //         {alphabetShow.map((line, index) => (
    //           <li key={index}>{line}</li>
    //         ))}
    //       </ol>
    //     </>
    //   );
    // } else if (numberShow?.length > 1) {
    //   return (
    //     <>
    //       <ol style={{ paddingLeft: '16px', margin: '0px' }}>
    //         {numberShow.map((line, index) => (
    //           <li key={index}>{line}</li>
    //         ))}
    //       </ol>
    //     </>
    //   );
    // } else {
    //   return currentTypeWriterQuestion()?.helperText;
    // }
  };

  return (
    <Box sx={WebStyle.bot_chat_all_message}>
      <AppBar
        position="sticky"
        sx={{ width: { sm: `100%` }, bgcolor: 'white' }}
      >
        <Toolbar>
          <ArrowBackOutlinedIcon
            sx={{
              color: tokens.palette_primary,
              cursor: 'pointer',
              width: '24px',
              height: '24px',
              marginRight: '16px',
            }}
            onClick={() => {
              handleBack();
            }}
          />
          <Card
            elevation={0}
            sx={{
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              overflow: 'auto',
              '&::-webkit-scrollbar': { display: 'none' },
            }}
          >
            {uniqueAgencyData &&
              uniqueAgencyData.map((item, index) => {
                return (
                  <>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        // background: '#EAEAEA',
                        // BACKGROUND OF THE SELECTED CONTACT
                        backgroundColor: 'rgba(234, 234, 234, 0.6)',
                        padding: '6px 12px',
                        borderRadius: '6px',
                        marginRight: '12px',
                      }}
                    >
                      <CardHeader
                        sx={{
                          padding: 0,
                          whiteSpace: 'nowrap',
                          marginRight: '4px',
                        }}
                        avatar={
                          <Avatar
                            variant="rounded"
                            src={item?.image}
                            alt="country-flag"
                            sx={{
                              width: 32,
                              height: 24,
                              border: '1px solid transparent',
                            }}
                          />
                        }
                        title={
                          <EntityText
                            sx={{ fontSize: '0.775rem', lineHeight: '1.00rem' }}
                          >
                            {item?.label}
                          </EntityText>
                        }
                        subheader={
                          <OriginText
                            sx={{
                              fontSize: '0.775rem',
                              lineHeight: '0.975rem',
                            }}
                          >
                            {item?.location}
                          </OriginText>
                        }
                      />
                      <Box sx={{ display: 'flex' }}>
                        {
                          <CloseIcon
                            sx={{
                              height: '20px',
                              width: '20px',
                              borderRadius: '100%',
                              cursor: 'pointer',
                              marginLeft: '6px',
                            }}
                            onClick={() => deleteByIdAgent(item?._id)}
                          />
                        }
                      </Box>
                    </Box>
                  </>
                );
              })}
            <AddIcon
              sx={{ cursor: 'pointer', borderRadius: '100%', fontSize: '28px' }}
              onClick={handleAddAgencyOpen}
            />
            {/* <AddIcon sx={{ cursor: 'pointer', borderRadius: '100%', fontSize: '28px' }} onClick={handleAddAgencyOpen} /> */}
          </Card>
          <Box flexGrow={1} />
          <IconButton
            aria-label="settings"
            sx={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <MoreVertIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          padding: '20px',
          // backgroundColor: 'rgba(231,233,235,255)',
          // ENTIRE UI BACKGROUND COLOR
          backgroundColor: tokens.token_surface,
          height: { xs: 'calc(100vh - 56px)', md: 'calc(100vh - 64px)' },
        }}
      >
        <Grid container columnSpacing={3} sx={{ height: '100%' }}>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              height: { xs: '100px', md: '100%' },
              marginBottom: '20px',
              ...(currentQuestionData?.data?.[0]?.answer_type?.trim() ==
              'startq'
                ? { display: 'none' }
                : ''),
            }}
          >
            <Box
              sx={{
                // backgroundColor: 'rgba(255,255,255,255)',
                // BACKGROUND COLOR OF THE HELPER TEXT
                backgroundColor: tokens.token_surface,
                border: `1px solid ${tokens.token_grey_300}`,
                borderRadius: '16px',
                padding: '16px',
                height: { xs: '100px', md: '100%' },
                overflow: 'auto',
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
              }}
            >
              <HelperText>
                {currentTypeWriterQuestion()?.helperText && (
                  <Markdown>{currentTypeWriterQuestion()?.helperText}</Markdown>
                )}
              </HelperText>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={
              currentQuestionData?.data?.[0]?.answer_type?.trim() == 'startq'
                ? 12
                : 6
            }
            sx={{ height: { xs: 'calc(100vh - 224px)', md: '100%' } }}
          >
            <Box
              // Right hand side box with input and Q & A
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                borderRadius: '16px',

                height: { xs: 'calc(100vh - 224px)', md: '100%' },
                overflow: 'auto',
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
              }}
              ref={messageEl}
            >
              <Box
                sx={{
                  // MESSAGES AREA BACKGROUND COLOR
                  backgroundColor:
                    tampBubble?.length === 0
                      ? tokens.token_surface
                      : tokens.token_surface,
                  // : 'rgb(238, 238, 238)',
                  // ? 'rgba(231,233,235,255)'

                  borderRadius: '16px',
                  display: `${
                    currentQuestionData?.data?.[0]?.answer_type?.trim() ==
                      'startq' && 'flex'
                  }`,
                  justifyContent: `${
                    currentQuestionData?.data?.[0]?.answer_type?.trim() ==
                    'startq'
                      ? 'center'
                      : 'flex-end'
                  }`,
                  alignItems: `${
                    currentQuestionData?.data?.[0]?.answer_type?.trim() ==
                      'startq' && 'center'
                  }`,
                }}
              >
                <Box
                  // Question and answer box
                  sx={{
                    minHeight: {
                      xs: `calc(100vh - (${questionBoxHeight}px + 245px))`,
                      md: `calc(100vh - (${questionBoxHeight}px + 124px))`,
                    },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: `${
                      currentQuestionData?.data?.[0]?.answer_type?.trim() ==
                      'startq'
                        ? 'center'
                        : 'flex-start'
                    }`,
                    alignItems: `${
                      currentQuestionData?.data?.[0]?.answer_type?.trim() ==
                      'startq'
                        ? 'center'
                        : 'flex-end'
                    }`,
                  }}
                >
                  {currentQuestionData?.data?.[0]?.answer_type?.trim() ==
                    'startq' && (
                    <Box sx={WebStyle.startHindQHelperText}>
                      {currentTypeWriterQuestion()?.helperText && (
                        <Markdown>
                          {currentTypeWriterQuestion()?.helperText}
                        </Markdown>
                      )}
                    </Box>
                  )}
                  {messagesArray
                    .filter((item) => item.shownData !== true)
                    .map((data) => {
                      return (
                        <Grid>
                          <Box sx={WebStyle.chat_message_send}>
                            <Box>
                              <Typography
                                display="flex"
                                flexDirection="column"
                                sx={{
                                  margin: '12px',
                                  // QUESTION BACKGROUND COLOR
                                  // background: 'rgb(238, 238, 238)',
                                  background: tokens.token_grey_100,
                                  padding: '12px 12px 12px 15px',
                                  border: `1px solid ${tokens.token_surface})`,
                                  // border: `1px solid rgb(204, 204, 204)`,
                                  borderRadius: '20px 20px 0 0',
                                }}
                              >
                                <span style={WebStyle.message_font}>
                                  {data?.question}
                                </span>
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                background: tokens.palette_primary,
                                padding: '10px 20px',
                                borderRadius: '0px 0px 30px 30px',
                              }}
                            >
                              {typeof data?.answer === 'object' ? (
                                data?.answer?.map((answerData) => {
                                  return answerData.includes('image') ? (
                                    <img
                                      src={answerData}
                                      style={{
                                        borderRadius: '10px',
                                        margin: '2px',
                                      }}
                                      height="auto"
                                      width="190"
                                      alt="Converted to Base64"
                                    />
                                  ) : answerData.includes('application/pdf') ? (
                                    <embed
                                      src={answerData}
                                      type="application/pdf"
                                      style={{
                                        borderRadius: '10px',
                                        margin: '2px',
                                      }}
                                      width="350px"
                                      height="300px"
                                    />
                                  ) : (
                                    ''
                                  );
                                })
                              ) : (
                                <Typography
                                  display="flex"
                                  flexDirection="column"
                                >
                                  <span style={WebStyle.message_answer}>
                                    {data.answer}
                                  </span>
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        </Grid>
                      );
                    })}
                </Box>
              </Box>
              <Box
                sx={{
                  position: 'sticky',
                  bottom: '0',
                  borderRadius: '16px',
                }}
              >
                {!lastQuestionFlag ? (
                  <Paper
                    elevation={3}
                    sx={{
                      width: '100%',
                      // INPUT AREA BACKGROUND COLOR
                      backgroundColor: tokens.token_grey_100,
                      // backgroundColor: 'rgb(238, 238, 238)',
                      border: `1px solid rgb(204, 204, 204)`,
                      // boxShadow: '0 4px 12px rgb(32 33 36 / 28%)',
                      borderRadius: '16px',
                      position: 'sticky',
                      bottom: 0,
                      marginTop: '20px',
                      padding: '25px 25px 25px 25px',
                      ...(currentQuestionData?.data?.[0]?.answer_type?.trim() ==
                      'startq'
                        ? {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }
                        : ''),
                    }}
                    ref={myQuestionBoxRef}
                  >
                    {questionsLoading ? (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          minHeight: '130px',
                          width: '100%',
                        }}
                      >
                        <BeatLoader
                          style={{ color: `${tokens.palette_primary}` }}
                        />
                      </Box>
                    ) : (
                      <>
                        <Box
                          sx={{
                            display: 'flex',
                            overflowX: 'scroll',
                            '&::-webkit-scrollbar': {
                              display: 'none',
                            },
                          }}
                        >
                          <span
                            style={{
                              padding: '5px 5px',
                              fontFamily: 'Roboto, Arial,  sans-serif',
                              fontSize: '20px',
                              fontWeight: 400,
                              width: '100%',
                              color: tokens.palette_primary,
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                width: '100%',
                                justifyContent: 'space-between',
                              }}
                            >
                              {currentTypeWriterQuestion()?.mainHeader && (
                                <TopHeaderShow
                                  style={{
                                    lineHeight: '1.6rem',
                                  }}
                                >
                                  {currentTypeWriterQuestion()?.mainHeader}
                                </TopHeaderShow>
                              )}
                            </Box>
                            <Box
                              // Box around the typewriter question above the input box
                              sx={{
                                display: 'flex',
                                width: '100%',
                                justifyContent: 'space-between',
                                fontWeight: 400,
                              }}
                            >
                              <Typewriter
                                options={{
                                  strings:
                                    currentTypeWriterQuestion()?.question,
                                  autoStart: true,
                                  loop: false,
                                  delay: 30,
                                }}
                              />
                            </Box>
                          </span>
                        </Box>
                        <Box
                          sx={{
                            ...(currentQuestionData?.data?.[0]?.answer_type?.trim() ==
                            'startq'
                              ? { paddingTop: '0px', display: 'flex' }
                              : { paddingTop: '25px', display: 'flex' }),
                          }}
                        >
                          {/* common function inputgenrater */}
                          {inputGenerator()}
                        </Box>
                      </>
                    )}
                  </Paper>
                ) : (
                  <Box
                    sx={{
                      width: '100%',
                      backgroundColor: tokens.token_grey_100,
                      borderRadius: '16px',
                      marginTop: '20px',
                    }}
                    ref={myQuestionBoxRef}
                  >
                    <Box
                      sx={{
                        padding: '25px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box sx={{ display: 'flex' }}>
                        <Box sx={{ margin: '0 20px 0 0', cursor: 'pointer' }}>
                          <Image
                            src={document_text}
                            height="35px"
                            width="35px"
                            onClick={handleOpenReviewModel}
                          />
                        </Box>
                        <Box sx={{ margin: '0 20px', cursor: 'pointer' }}>
                          <Image
                            src={email}
                            height="35px"
                            width="35px"
                            onClick={handleEmailButtonClick}
                          />
                        </Box>
                      </Box>
                      <Box>
                        <Button
                          disableElevation
                          variant="contained"
                          sx={{
                            textTransform: 'none',
                            height: '45px',
                            borderRadius: '14px',
                            whiteSpace: 'nowrap',
                          }}
                          onClick={handleSubmitReport}
                          disabled={getAgencyDataById.length === 0}
                        >
                          Submit Report
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      {/* select new agency added model */}
      <Dialog
        open={openAddAgencyModel}
        onClose={handleAddAgencyClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Select agency</DialogTitle>
        <Divider />
        <Divider />
        <DialogContent sx={{ padding: '0px 25px 0px 25px' }}>
          <DialogContentText>
            {filteredArrayAgency.length == 0 ? (
              <Typography sx={{ margin: '25px 0', textAlign: 'center' }}>
                No agency found
              </Typography>
            ) : (
              <>
                {filteredArrayAgency.map((item) => {
                  return (
                    <CardHeader
                      onClick={() => handleAgencyDataClick(item)}
                      sx={{ padding: 0, margin: '10px 0', cursor: 'pointer' }}
                      avatar={
                        <Avatar
                          variant="rounded"
                          src={item?.image}
                          alt="country-flag"
                          sx={{
                            width: 32,
                            height: 24,
                            border: '1px solid transparent',
                          }}
                        />
                      }
                      title={
                        <EntityText
                          sx={{ fontSize: '0.775rem', lineHeight: '1.00rem' }}
                        >
                          {item?.label}
                        </EntityText>
                      }
                      subheader={
                        <OriginText
                          sx={{ fontSize: '0.775rem', lineHeight: '0.975rem' }}
                        >
                          {item?.location}
                        </OriginText>
                      }
                    />
                  );
                })}
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <Divider />
        <Divider />
        <DialogActions>
          <Button onClick={handleAddAgencyClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* bank details show model */}
      <Dialog
        open={openBankDetailsPopUp}
        onClose={handleBankDetailsPopUpClose}
        fullWidth
        maxWidth="xs"
        onClick={handleBackdropClick}
      >
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ dirty, isValid, values, handleChange, handleBlur }) => {
            return (
              <Form>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                  <SecurityIcon sx={{ marginRight: '6px' }} />
                  Fraud Protection Block
                </DialogTitle>
                <Divider />
                <Divider />
                <DialogContent sx={{ padding: '0px 25px 0px 25px' }}>
                  <DialogContentText>
                    <Box sx={{ margin: '16px 0' }}>
                      <Grid item container spacing={2} justify="center">
                        <Grid item xs={12}>
                          <Field
                            label="Bank Account Number"
                            variant="outlined"
                            fullWidth
                            name="bankAccountNumber"
                            value={values.bankAccountNumber}
                            component={TextFieldFormik}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Field
                            label="Bank Account Pin"
                            variant="outlined"
                            fullWidth
                            name="bankAccountPin"
                            value={values.bankAccountPin}
                            component={TextFieldFormik}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Field
                            label="Bank Account Password"
                            variant="outlined"
                            fullWidth
                            name="bankPassword"
                            value={values.bankPassword}
                            component={TextFieldFormik}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </DialogContentText>
                </DialogContent>
                <Divider />
                <Divider />
                <DialogActions>
                  <Button onClick={handleBankDetailsPopUpClose} color="primary">
                    Close
                  </Button>
                  <Button
                    disableElevation
                    variant="text"
                    type="submit"
                    onSubmit={onSubmit}
                  >
                    Submit
                  </Button>
                </DialogActions>
              </Form>
            );
          }}
        </Formik>
      </Dialog>

      {/* Review page modal UI */}
      <Dialog
        open={openReviewModel}
        onClose={handleCloseReviewModel}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>Review page</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {tampBubble.map((item) => (
              <div key={item[0].id}>
                {item.map((qna) => (
                  <Box key={qna.id}>
                    <h3>Question:- {qna.question}</h3>
                    {typeof qna?.answer === 'object' ? (
                      qna?.answer?.map((answerData) => {
                        return answerData.includes('image') ? (
                          <img
                            src={answerData}
                            style={{ borderRadius: '10px', margin: '2px' }}
                            height="auto"
                            width="190"
                            alt="Converted to Base64"
                          />
                        ) : answerData.includes('application/pdf') ? (
                          <embed
                            src={answerData}
                            type="application/pdf"
                            style={{ borderRadius: '10px', margin: '2px' }}
                            width="350px"
                            height="300px"
                          />
                        ) : (
                          ''
                        );
                      })
                    ) : (
                      <Typography display="flex" flexDirection="column">
                        <span style={WebStyle.message_answer_review}>
                          Answer:-&nbsp; {qna.answer}
                        </span>
                      </Typography>
                    )}
                  </Box>
                ))}
              </div>
            ))}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseReviewModel} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

interactive_report_new.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default interactive_report_new;
